import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../../network/API";
import { phpClient } from "../../../network";

interface CreateUnavailabilityPayload {
  start_date?: string | undefined;
  end_date?: string | undefined;
  from_time?: string | undefined;
  to_time?: string | undefined;
  all_day?: 0 | 1;
  repeating?: 0 | 1;
  repeat_days?: string | undefined;
  note?: string | undefined;
  overwrite_existing_slots?: 0 | 1;
}

export const createUnavailability = createAsyncThunk(
  "schedule/createUnavailability",
  async (payload: CreateUnavailabilityPayload, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      const response = await phpClient.post<any>({
              url:"/schedule/create_unavailability",
              data: payload,
            });
      return response.data;  // expects { status, data, message }
    } catch (error: any) {
      console.log(error, "error in createUnavailability");
            return rejectWithValue(JSON.parse(JSON.stringify(error.message)) || "An error occurred");
        } 
  }
);
